import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, parseISO } from "date-fns";
import { enUS } from "react-date-range/dist/locale";
import { getLastDateOfMonth } from "../Utility/utility";
import { setDateRange } from "./action";
import { useDispatch } from "react-redux";

export const DropdownDateRangePicker = ({
  initialStartDate,
  initialEndDate,
  minDate,
  maxDate,
  width,
  dateRange,
  // setDateRange,
  formatDateRecoTab,
  tab,
  selection
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const handleSelect = (ranges) => {
    // setDateRange([ranges.selection]);
    dispatch(setDateRange([ranges.selection]));
  };
  // useEffect(() => {
  //   dispatch(setDateRange([
  //     {
  //       startDate: new Date(initialStartDate),
  //       endDate: new Date(initialEndDate),
  //       key: "selection",
  //     },
  //   ]))
    
    
  // }, [initialStartDate, initialEndDate]);

useEffect(() => {
   dispatch(setDateRange([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
   ]))
}, [initialStartDate, initialEndDate]);

  const toggleDropdown = () => {
    if(selection !== 'Document Date'){
      setIsOpen(false)
    }
   
  else{
    setIsOpen(!isOpen);
  }
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  // const handleClear = () => {
  //   dispatch(setDateRange([
  //     {
  //       startDate: new Date(initialStartDate),
  //       endDate: new Date (initialEndDate),
  //       key: "selection",
  //     },
  //   ]));
  // };
const handleClear = () => {
  dispatch(setDateRange([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]));
};
  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // const formatDate = (date) => {
  //    return date ? format(date, "dd MMM") : "";
  //   // return date ? format(parseISO(date), "dd MMM") : "";
  // };
  const formatDate = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      try {
        return format(parseISO(date), "dd MMM");
      } catch {
        console.error("Invalid ISO date string:", date);
        return "";
      }
    }
    return format(date, "dd MMM");
  };
  // useEffect(() => {
  //   console.log("startDate::",startDate)
  //   console.log("endDate::",endDate)
  //   console.log("formatDate startDate", formatDate(startDate));
  //   console.log("formatDate endate",formatDate(endDate));

  // });

  const { startDate, endDate } = dateRange[0];
  // const { startDate, endDate } = dateRange[0] || {};

// Parse the dates
const parsedStartDate = startDate ? parseISO(startDate) : null;
const parsedEndDate = endDate ? parseISO(endDate) : null;
  useEffect(() => {
    // console.log("startDate::",startDate)
    // console.log("endDate::",endDate)
    // console.log("parsedEndDate::",parsedEndDate)
    // // console.log("dateRange[0]:",dateRange[0]) 
    // // console.log("formatDateRecoTab startDate", formatDateRecoTab(startDate));
    // console.log("formatDateRecoTab endate",formatDateRecoTab(endDate));
    // console.log("formatDate endate",formatDate(endDate));
      // console.log('mindate::',minDate instanceof Date ? minDate : new Date(minDate))
      // console.log("maxDate::",maxDate ? getLastDateOfMonth(maxDate) : maxDate)

  });
  // useEffect(() => {
  //   console.log("startDate::", startDate);
  //   console.log("endDate::", endDate);
  //   console.log("initialStartDate::", initialStartDate);
  //   console.log("initialEndDate::", initialEndDate);
  // }, [startDate, endDate,initialStartDate,initialEndDate]);

  // useEffect(() => {
  //   console.log("props.dateRange ::", dateRange);
  // });
 
  return (
    <div
      style={{ position: "relative", width: width ? width : "203px" }}
      ref={dropdownRef}
    >
      {/* {JSON.stringify(dateRange)} */}
      <button
        onClick={toggleDropdown}
        style={{
          width: "100%",
          paddingTop: "5px",
          paddingBottom: "5px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          backgroundColor: "#fff",
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        
        {startDate && endDate && tab && selection === 'Document Date'?  (
          `${formatDateRecoTab(startDate)} - ${formatDateRecoTab(endDate)}`
        ) :
        (
          // "Select Document Date Range"
          <div style={{ display: "flex" }}>
            <span
              style={{
                display: "flex",
                justifyContent: "flex-start",
                color: "#007bff",
              }}
            >
              Select Document Date Range
            </span>
            {/* <div
           className="triangle-icon"
           style={{top:'54%'}}
           ></div> */}
          </div>
        )}
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            // top: "100%",
            left: 0,
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            // padding: "10px",
            transform: "scale(0.8)",
            transformOrigin: "top left",
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            showDateDisplay={false}
            // minDate={minDate instanceof Date ? minDate : new Date(minDate)}
            // maxDate={maxDate ? getLastDateOfMonth(maxDate) : maxDate}
            minDate={new Date(2015, 0, 1)}
            maxDate={new Date(new Date().getFullYear() + 5, 11, 31)}
             rangeColors={["#6B46C1"]}
            locale={enUS}
            styles={{
              calendarWrapper: { transform: "scale(0.8)" },
            }}
          />
          <div
            style={{
              marginRight: "12px",
              marginBottom: "3px",
              textAlign: "right",
              cursor: "pointer",
              color: "#6B46C1",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            onClick={handleClear}
          >
            Clear
          </div>
        </div>
      )}
    </div>
  );
};
